export class ActionSnoozePostDateTimeOnly {
    date: string; //ISO string
}

export class ActionSnoozePostFull {
    days?: number;
    months?: number;
    date?: string; //ISO string
}
